import React, { Component } from 'react';
import classnames from 'classnames/bind';
import { bool, string } from 'prop-types';

import styles from './RadioButton.css';

class RadioButton extends Component {
  static propTypes = {
    disabled: bool,
    darkBg: bool,
    error: string,
    label: string
  };

  state = { isChecked: false, hasError: false };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.defaultChecked && !prevState.isChecked) {
      return { isChecked: true };
    }

    if (nextProps.error && nextProps.error.length && !prevState.hasError) {
      return { hasError: true };
    }

    return null;
  }

  toggleChecked = () => {
    this.setState({ isChecked: !this.state.isChecked });
  }

  render() {
    const { disabled, label, darkBg, error } = this.props;
    const { isChecked, hasError } = this.state;
    const cx = classnames.bind(styles);
    const inputFieldClasses = cx({
      inputField: true,
      error: hasError,
      darkBg
    });

    return (
      <div className={inputFieldClasses}>
        <input
          className={styles.input}
          type='checkbox'
          disabled={disabled}
          checked={isChecked}
          onClick={this.toggleChecked}
        />
        {label && <p>{label}</p>}
        <div className={styles.toggable}></div>
        { hasError && <p className={`${styles.error} small`}>{error}</p> }
      </div>
    );
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/RadioButton.js